import React, { FC } from "react";
import { noop } from "src/globalConsts";
import { useTemplateModuleMetadataById } from "src/store/modules/useSelectors";
import { useDismissNotfications } from "src/store/notifications/useActions";
import { useTheme } from "../../../../config/emotion";
import { TemplateId } from "../../../../globalTypes";
import { useNotificationsForTemplate } from "../../../../store/notifications/useSelectors";
import { createNotificationViewLink } from "../../../../utils/internalLinksParsing";
import { getNotificationColor } from "../../../molecules/cards/TemplateCard/variants/kpi/utils";
import NotificationIndicator, {
  ControlledProps,
} from "../NotificationIndicator";

const TemplateContainer: FC<Props> = ({
  templateId,
  onClick = noop,
  ...rest
}) => {
  const { colors } = useTheme();
  const metadata = useTemplateModuleMetadataById(templateId);
  const templateNotifications = useNotificationsForTemplate(templateId);
  const resolveNotifications = useDismissNotfications();
  const { keyColName = "", kpiMetadata = null } = metadata ?? {};

  const notificationCount = templateNotifications.length;

  const linkTo = createNotificationViewLink({
    templateId,
    primaryColumnName: keyColName,
    keysOfDisplayedRows: templateNotifications.map((n) =>
      Number(n.recordPrimaryKey)
    ),
  });

  const handleOnBadgeClick = () => {
    const notifIds = templateNotifications.map(
      ({ notificationId }) => notificationId
    );
    resolveNotifications(notifIds);
    onClick();
  };

  return (
    <NotificationIndicator
      {...rest}
      notificationCount={notificationCount}
      backgroundColor={
        // I <3 PRETTIER
        getNotificationColor(kpiMetadata, colors, notificationCount)
      }
      onClick={handleOnBadgeClick}
      linkTo={linkTo}
    />
  );
};

export type Props = Pick<
  ControlledProps,
  "onClick" | "className" | "displayWhenZero"
> & {
  templateId: TemplateId;
};

export default TemplateContainer;
export type ContainerProps = Props;
